import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import { getDVD } from "../../../../state/selectors/DVD.selectors";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import PublicationLinks from "../../../../components/Publications/components/PublicationLinks";

const DVD = ({ dvdData }) => {
  const pathoColor = dvdData?.pathogenicity
    ? getPathogenicityColorByAllNames(dvdData.pathogenicity)
    : "black";
  return dvdData ? (
    <div className="varsome-result-fixed">
      <div className="varsome-container varsome-container__basic">
        <ComponentPanel
          title={
            <React.Fragment>
              <a
                href={getVarsoUrl("https://deafnessvariationdatabase.org/")}
                target="_blank"
              >
                Deafness Variation Database
              </a>
            </React.Fragment>
          }
          version={dvdData?.version ? dvdData?.version : ""}
          componentName="DVDComp"
          content={
            <React.Fragment>
              <div className="tw-bg-white tw-text-sm tw-p-3">
                {dvdData?.pathogenicity && (
                  <div className="tw-flex tw-items-center">
                    <p className="tw-m-0 tw-text-xs tw-mr-2">
                      Variant Classification:
                    </p>
                    <div>
                      <b
                        style={{
                          color: pathoColor,
                        }}
                      >
                        {dvdData.pathogenicity}
                      </b>
                    </div>
                  </div>
                )}
                {dvdData?.disease && (
                  <div className="tw-flex tw-items-center">
                    <p className="tw-m-0 tw-text-xs tw-mr-2">Disease:</p>
                    <div>
                      <b>{dvdData.disease}</b>
                    </div>
                  </div>
                )}
                {dvdData?.comment && (
                  <div className="tw-flex tw-items-center">
                    <p className="tw-m-0 tw-text-xs tw-mr-2">Comment:</p>
                    <div>{dvdData.comment}</div>
                  </div>
                )}
                {dvdData?.pub_med_references && (
                  <div>
                    <p className="tw-m-0 tw-text-xs tw-mr-2">Publications:</p>
                    <PublicationLinks
                      limit={10}
                      ids={dvdData.pub_med_references}
                    />
                  </div>
                )}
              </div>
            </React.Fragment>
          }
        />
      </div>
    </div>
  ) : null;
};

DVD.propTypes = {
  dvdData: PropTypes.shape({
    pathogenicity: PropTypes.string,
    disease: PropTypes.string,
    comment: PropTypes.string,
    version: PropTypes.string,
    pub_med_references: PropTypes.arrayOf(PropTypes.number),
  }),
};

DVD.defaultProps = {
  dvdData: null,
};

const mapStateToProps = (state) => ({
  dvdData: getDVD(state),
});

export default connect(mapStateToProps, {})(DVD);
